import { VPAuthConfig } from '@vp/ubik-context'

export const createAuthConfig = (culture: string): VPAuthConfig => ({
  culture,
})
